import { BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";
import Hamburger from 'hamburger-react'
import { Component } from "react";



// TODO: set state of dropdown menu open or closed in NAVBAR (lift state up thx)
// also: https://www.kirupa.com/react/smooth_sliding_menu_react_motion.htm





class NavBar extends Component{
    constructor(props){
        super(props)
        this.state = {open:false, location:"Home"}
        this.toggleOpen = this.toggleOpen.bind(this);
        this.setNewLocation = this.setNewLocation.bind(this);

    }

    toggleOpen(){
        this.setState({open:!this.state.open})
    }

    setNewLocation(loc){
        this.setState({location:loc});
    }

    render(){
        return(
            <div className="topBar">
                <div className="title inline">David Marino // design && research</div>
                <div className="miniTitle inline">://dvdmrn</div>
                <div className="menuItems inline ">
                    <div>
                        <MenuItem path="/" text="Home"/>
                        <MenuItem path="/about" text="About" />
                        <MenuItem path="/projects" text="Projects" />
                        <span> 
                            <a href="https://scholar.google.ca/citations?user=dLgup7MAAAAJ&hl=en" 
                                className="menuItem"
                                target="_blank"
                                rel="noopener noreferer">
                                    Publications
                            </a> 
                        </span>
                        <MenuItem path="/visual" text="Visual" />
                        <MenuItem path="/contact" text="Contact" />
                    </div>
    
                </div>
                <div className="hamburgerIcon inline">
                    <Hamburger 
                        toggle={this.toggleOpen}
                        toggled={this.state.open}
                        onToggle={
                        toggled =>{
                            if(toggled){
                                this.setState({open:true})
                            }
                            else{
                                this.setState({open:false})
                            }
                        }
                    }/>
                </div>
                <DropdownMenu class={this.state.open ? "openMenu" : "closeMenu"} 
                              toggleFn={this.toggleOpen}/>
            
            </div>
        )
    }
}

// function MenuItem(props){
//     const location = useLocation();
//     console.log(location.pathname)

//     return(
//         <span>
//             <Link to="/"
//                 className={`menuItem ${location.pathname == props.path ? "selected" : ""}`}
//                 onClick={e => props.setNewLocation(props.target)}>
//                 {props.target}
//             </Link>
//         </span>
//     )
// }

function MenuItem(props) {
    const location = useLocation();
    
    return (
        <span>
            <Link to={props.path}
                className={`menuItem ${location.pathname == props.path ? "selected" : ""}`}>
                {props.text}
            </Link>
        </span>
    )
}

function DropdownMenu(props){

    return(
     
            <div id="dropdownMenu" className={props.class}>
                <Link to="/"         className="ddMenuItem" onClick={props.toggleFn}><div>Home</div></Link>
                <Link to="/about" className="ddMenuItem" onClick={props.toggleFn}><div>About</div></Link>
                <Link to="/projects" className="ddMenuItem" onClick={props.toggleFn}><div>Projects</div></Link>
                <a href="https://scholar.google.ca/citations?user=dLgup7MAAAAJ&hl=en" className="ddMenuItem" onClick={props.toggleFn}><div>Publications</div></a>
                <Link to="/visual" className="ddMenuItem" onClick={props.toggleFn}><div>Visual</div></Link>
                <Link to="/contact" className="ddMenuItem" onClick={props.toggleFn}><div>Contact</div></Link>

            </div>
     
    )
}



export {NavBar}